<template>
    <div>
        <nav class="w3-sidebar w3-collapse w3-white" style="z-index:3;width:300px" id="nav-sidebar">
            <div class="w3-container">
                <a @click="navClose()" class="w3-hide-large w3-right we-jumbo we-padding w3-hover-grey" title="close menu">
                    <i class="fa-solid fa-xmark"></i>
                </a>
                <br>
                <img src="/guineafowl.jpeg" style="width:100%;" class="w3-round"><br><br>
                <h4><b>LIFE LIST TRACKER</b></h4>
            </div>
            <div class="w3-bar-block">
                <router-link
                    to="/"
                    class="w3-bar-item w3-button w3-padding"
                    exactActiveClass="w3-text-teal"
                    @click="navClose()"
                >
                    <i class="fa fa-house fa-fw w3-margin-right"></i>
                    HOME
                </router-link>
                <router-link
                    to="/list"
                    class="w3-bar-item w3-button w3-padding"
                    exactActiveClass="w3-text-teal"
                    @click="navClose()"
                >
                    <i class="fa-solid fa-feather-pointed fa-fw w3-margin-right"></i>
                    LIFE LIST
                </router-link> 
                <router-link
                    to="/status"
                    class="w3-bar-item w3-button w3-padding"
                    exactActiveClass="w3-text-teal"
                    @click="navClose()"
                >
                    <i class="fa-solid fa-chart-column fa-fw w3-margin-right"></i>
                    STATUS TRACKER
                </router-link> 
                <router-link
                    to="/bigday"
                    class="w3-bar-item w3-button w3-padding"
                    exactActiveClass="w3-text-teal"
                    @click="navClose()"
                >
                    <i class="fa-solid fa-fire fa-fw w3-margin-right"></i>
                    BIG DAY
                </router-link>
                <router-link
                    to="/about"
                    class="w3-bar-item w3-button w3-padding"
                    exactActiveClass="w3-text-teal"
                    @click="navClose()"
                >
                    <i class="fa fa-question fa-fw w3-margin-right"></i>
                    ABOUT
                </router-link>
            </div>
            <div class="w3-container">
                <h4><b>EXTERNAL LINKS</b></h4>
            </div>
            <div class="w3-bar-block">
                <a
                    href="https://carson.cknoble.com"
                    class="w3-bar-item w3-button w3-padding"
                >
                    <i class="fa fa-laptop-code fa-fw w3-margin-right"></i>
                    carson.cknoble.com
                </a>
                <a
                    href="https://ebird.org/profile/NjY0NDM2Mw/US-IA"
                    class="w3-bar-item w3-button w3-padding"
                >
                    <i class="fa-solid fa-crow fa-fw w3-margin-right"></i>
                    eBird profile
                </a> 
            </div>
            <div class="w3-container w3-display-bottomleft" v-if="currentUser">
                <a @click.prevent="logOut" class="w3-button w3-black w3-margin-bottom">Log Out</a>
            </div>
        </nav>

        <div class="w3-overlay w3-hide-large w3-animate-opacity" @click="navClose()" style="cursor:pointer" title="close side menu" id="nav-overlay"></div>
    </div>
</template>

<script setup>
function navClose() {
    document.getElementById("nav-sidebar").style.display = "none";
    document.getElementById("nav-overlay").style.display = "none";
}
</script>

<script>
export default {
    name: 'NavigationPane',
    methods: {
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/');
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    }
}
</script>

<style scoped>
</style>
